import { AccountGroupApiService, ProjectionFilter } from '@galaxy/account-group';
import { EMPTY, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

export interface LocalTimeObj {
  address: string;
  timezone: string;
}

@Injectable()
export class LocalTimeCardService {
  constructor(private readonly accountGroupSdk: AccountGroupApiService) {}

  getLocalTime(agid: string): Observable<LocalTimeObj> {
    if (!agid) {
      return EMPTY;
    }

    const projectionFilter = new ProjectionFilter({ napData: true });
    return this.accountGroupSdk.get(agid, projectionFilter).pipe(
      switchMap((ag) =>
        of({
          address: ag?.napData?.city,
          timezone: ag?.napData?.timezone,
        } as LocalTimeObj),
      ),
    );
  }
}
